import {ArrayFilterPredicate} from 'src/hooks/filtered-data/array-filter-predicate';
import {DateFilterPredicate} from 'src/hooks/filtered-data/date-filter-predicate';
import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';
import {StringFilterPredicate} from 'src/hooks/filtered-data/string-filter-predicate';
import {Filters} from 'src/modules/events/typedefs';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';

export const createPredicates = (filters: Filters): FilterPredicate<EventBasicInfo>[] => {
    return [
        new StringFilterPredicate((row: EventBasicInfo) => row.source, filters.source),
        new StringFilterPredicate((row: EventBasicInfo) => row.type, filters.type),
        new ArrayFilterPredicate((row: EventBasicInfo) => row.families, filters.families),
        new StringFilterPredicate((row: EventBasicInfo) => row.code, filters.code),
        new StringFilterPredicate((row: EventBasicInfo) => row.description, filters.description),
        new ArrayFilterPredicate((row: EventBasicInfo) =>
            row.attributes.map(attribute => attribute.name), filters.attributes),
        new DateFilterPredicate((row: EventBasicInfo) => row.lastUsageDate, filters.lastUsageDate),
        new DateFilterPredicate((row: EventBasicInfo) => row.firstUsageDate, filters.firstUsageDate),
    ];
};
